import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { CopyButton } from '@/components/ui/CopyButton'
import { VaultAskCaiButton } from './VaultAskCaiButton'
import { useVault } from './VaultContext'

/** Typed into the composer for the carrier, never shown on the card itself. */
const VAULT_PROMPT = 'Add this to my vault…'

interface WayIn {
  label: string
  /** The address or number to reach, for the ways in that are one. */
  value?: string
  copy?: string
  /** The ask this way-in opens Ask Cai with, where Cai can take it directly. */
  prompt?: string
}

// Texting documents in works, but no number is configured to print here yet.
function waysIn(intakeEmail?: string): WayIn[] {
  return [
    ...(intakeEmail ? [{ label: 'Email documents', value: intakeEmail, copy: intakeEmail }] : []),
    { label: 'Add in chat', prompt: VAULT_PROMPT },
  ]
}

/** Every way a document reaches the vault that isn't the drop zone. */
export function VaultWaysIn({ intakeEmail }: { intakeEmail?: string }) {
  const { staff } = useVault()
  const all = waysIn(intakeEmail)
  // Ask Cai opens as the signed-in person, so for staff that way in is not one — and with
  // the button gone the row would be a label pointing at nothing.
  const rows = staff ? all.filter((way) => !way.prompt) : all

  return (
    <Card className="gap-3 py-5">
      <CardHeader>
        <CardTitle>Ways to fill your vault</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="flex flex-col gap-1 text-sm">
          {rows.map((way) => (
            <div key={way.label} className="flex items-center gap-x-1">
              <dt className="text-muted-foreground">{way.label}:</dt>
              <dd className="flex items-center gap-1 font-medium">
                {way.value}
                {way.copy && <CopyButton value={way.copy} />}
                {way.prompt && <VaultAskCaiButton prompt={way.prompt} />}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  )
}
